import { useIsAuthenticated, useMsal } from "@azure/msal-react"
import {
  Box,
  Container,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material"
import { StyledButton } from "components/Button/StyledButton"
import { useEffect } from "react" // Added useEffect
import { useNavigate } from "react-router"
import logo from "../../assets/logo.png"
import { loginRequest } from "../../authConfig" // Adjusted path

type LoginPageProps = {
  onLoginSuccess?: () => void
}

export const LoginPage = ({ onLoginSuccess }: LoginPageProps) => {
  const { instance, accounts } = useMsal()
  const isAuthenticated = useIsAuthenticated()
  const navigate = useNavigate()

  useEffect(() => {
    if (isAuthenticated && accounts[0]) {
      // User is logged in
      console.log("User authenticated:", accounts[0])
      // You might want to store user info (accounts[0]) in your global state here
      if (onLoginSuccess) {
        onLoginSuccess()
      } else {
        navigate("/projectportal/projects")
      }
    }
  }, [isAuthenticated, accounts, navigate, onLoginSuccess])

  const handleAzureLogin = (): void => {
    instance.loginPopup(loginRequest).catch((e) => {
      console.error("Login failed:", e)
      // Handle login errors (e.g., display a message to the user)
    })
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        width: "100vw",
        bgcolor: "background.default",
      }}
    >
      <Container maxWidth="sm">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 4,
          }}
        >
          <img src={logo} alt="Logo" style={{ maxHeight: "80px", marginBottom: "20px" }} />
          <Typography variant="h4" component="h1" gutterBottom>
            Willkommen bei LIMS
          </Typography>
          <Typography variant="body1" color="text.secondary" align="center">
            Bitte melden Sie sich an, um fortzufahren
          </Typography>
        </Box>

        <Box
          sx={{
            p: 3,
            borderRadius: 2,
            bgcolor: "background.paper",
            boxShadow: 3,
          }}
        >
          <DialogTitle sx={{ textAlign: "center", pb: 1 }}>Login</DialogTitle>
          <DialogContent>
            <Typography variant="body2" align="center" sx={{ mt: 2 }}>
              Melden Sie sich mit Ihrem Azure AD-Konto an.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3, pt: 2 }}>
            <StyledButton
              buttonType="custom"
              onClick={handleAzureLogin}
              fullWidth
              size="large"
              variant="contained"
            >
              Mit Azure AD Anmelden
            </StyledButton>
          </DialogActions>
        </Box>
      </Container>
    </Box>
  )
}
